//Making IIFE module to not litter the window object
(function () {
	// const updateMobileNav = () => {
	// 	const form = document.querySelector("collapsible-element.localization");
	// 	const nav = document.querySelector("nav.menu-drawer__navigation");
	// 	const bar = document.querySelector("#shopify-section-announcement-bar");
	// 	let barHeight = bar.offsetHeight + 5 || 55;

	// 	if (!form || !nav) return;
	// 	const scrollY = window.scrollY;
	// 	if (scrollY < 100) {
	// 		form.style.bottom = "0px";
	// 		nav.style.paddingBottom = "0px";
	// 		return;
	// 	}
	// 	form.style.bottom = barHeight + "px";
	// 	nav.style.paddingBottom = barHeight + "px";
	// 	return;
	// };

	const setSticky = () => {
		const bar = document.querySelector("#shopify-section-announcement-bar");
		const header = document.querySelector("#shopify-section-header");
		if (!bar || !header) return;
		bar.classList.add("announcement-bar--sticky");
		header.style.top = `${bar.offsetHeight - 1}px`;
		header.style.position = "sticky";
	};

	// if (window.innerWidth < 700) {
	// 	window.addEventListener("scroll", setSticky);
	// }

	setSticky();
})();
